import { faSortDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, notification } from 'src/common';
import {
  getUpdateCacheOnChangeEmployeeActiveStatus,
  useChangeEmployeeActiveStatus
} from 'src/models/company/Users/hooks';
import styles from './index.module.scss';

interface IEmployeeStatusBadgeProps {
  enabled?: boolean;
}

export const EmployeeStatusBadge: FC<IEmployeeStatusBadgeProps> = props => {
  const { enabled } = props;
  const { t } = useTranslation();

  return (
    <span className={classNames(styles.statusBadge, { [styles.isDisabled]: !enabled })}>
      {t(enabled ? 'Common.active' : 'Common.disabled')}
    </span>
  );
};

interface IProps {
  enabled?: boolean;
  email: string;
  top?: boolean;
}
export const EmployeeStatus: FC<IProps> = props => {
  const { email, enabled, top = false } = props;
  const { t } = useTranslation();
  const [menuVisible, setMenuVisible] = useState(false);
  const toggleMenu = useCallback(() => {
    setMenuVisible(!menuVisible);
  }, [menuVisible]);

  const [changeEmployeeActiveStatus] = useChangeEmployeeActiveStatus();

  const onSwitchEmployeeStatus = useCallback(() => {
    changeEmployeeActiveStatus({
      variables: { email, enabled: !enabled },
      update: getUpdateCacheOnChangeEmployeeActiveStatus(email)
    }).catch(() => {
      notification.error({
        description: t('Common.unknownErrorDesc'),
        message: t('Common.unknownError')
      });
    });
    toggleMenu();
  }, [changeEmployeeActiveStatus, email, enabled, t, toggleMenu]);

  return (
    <Dropdown
      trigger={['click']}
      getPopupContainer={triggerNode => triggerNode.parentNode as HTMLElement}
      visible={menuVisible}
      onVisibleChange={toggleMenu}
      overlayClassName={styles.statusMenu}
      placement={top ? 'topCenter' : 'bottomRight'}
      overlay={
        <div className={styles.menu}>
          <button className={styles.statusButton} onClick={onSwitchEmployeeStatus}>
            <EmployeeStatusBadge enabled={!enabled} />
          </button>
        </div>
      }
    >
      <button className={styles.statusButton}>
        <EmployeeStatusBadge enabled={enabled} />
        <FontAwesomeIcon icon={faSortDown} className={styles.statusButtonIcon} />
      </button>
    </Dropdown>
  );
};

export default EmployeeStatus;
